var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-level --is-level-3 --is-mobile"},[_c('Heading',{attrs:{"title":"Selbst zusammenstellen","subtitle":"Sie bestimmen jede Delikatesse.","level":"3"}}),_c('LevelCatalog',{ref:"catalog",attrs:{"listItems":_vm.listItems}}),_c('PresentContentMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }